export interface SearchResultItem {
  id: string;
  title: string;
  type: 'page' | 'document' | 'drawing' | 'asset';
  category: string;
  discipline: string;
  fileType?: string;
  url: string;
  content: string;
  meta?: {
    source?: string;
    revision?: string;
    published?: string;
    manufacturer?: string;
    location?: string;
    size?: string;
    section?: string;
  };
}

export const structuredSearchCatalog: SearchResultItem[] = [
  // PDF Documents in /public/documents/
  {
    id: 'doc-hifog-desc',
    title: 'Hi-Fog Descriptions & Design Criteria.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Hi-Fog descriptions & design criteria.pdf',
    content: 'High-pressure water mist fire suppression system description, zoning, and design criteria. Operating pressure 140 bar.',
    meta: {
      source: 'DrKW',
      revision: '04',
      published: '2016',
      size: '3.4 MB',
    },
  },
  {
    id: 'doc-hifog-sprinkler',
    title: 'Hi-Fog Sprinkler Design.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Hi-Fog sprinkler design.pdf',
    content: 'Detailed Hi-Fog sprinkler head placement, nozzle spray patterns, and hydraulic boundary conditions.',
    meta: {
      source: 'Marioff',
      revision: '02',
      published: '2016',
      size: '2.8 MB',
    },
  },
  {
    id: 'doc-hifog-calc',
    title: 'Hi-Fog Design Calculations.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Hi-fog design calculations.pdf',
    content: 'Hydraulic flow calculations, pipe sizing, and friction loss tables for Hi-Fog fire suppression.',
    meta: {
      source: 'DrKW',
      revision: '03',
      published: '2016',
      size: '1.9 MB',
    },
  },
  {
    id: 'doc-lg-des-crit',
    title: 'Lower Ground Floor Design Criteria.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Lower Ground Floor Design Criteria.pdf',
    content: 'Lower ground floor mechanical services design criteria, ventilation rates, and chilled water coil capacities.',
    meta: {
      source: 'Meinhardt',
      revision: '01',
      published: '2015',
      size: '4.1 MB',
    },
  },
  {
    id: 'doc-l2-core1',
    title: 'Level 2 Core 1 Design Criteria.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Level 2 Core 1 Design Criteria.pdf',
    content: 'Level 2 Core 1 HVAC design parameters, VAV box schedules, and supply air temperature setpoints.',
    meta: {
      source: 'Arup',
      revision: '02',
      published: '2015',
      size: '2.5 MB',
    },
  },
  {
    id: 'doc-l3-core1',
    title: 'Level 3 Core 1 Design Criteria.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Level 3 Core 1 Design Criteria.pdf',
    content: 'Level 3 Core 1 environmental control criteria and heating/cooling load calculations.',
    meta: {
      source: 'Arup',
      revision: '02',
      published: '2015',
      size: '2.6 MB',
    },
  },
  {
    id: 'doc-l6-cores',
    title: 'Level 6 Cores 1 & 2 Design Criteria.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Level 6 Cores 1 & 2 Design Criteria.pdf',
    content: 'Level 6 mechanical services design criteria and chilled water distribution loops.',
    meta: {
      source: 'Arup',
      revision: '03',
      published: '2016',
      size: '3.0 MB',
    },
  },
  {
    id: 'doc-westco-duct',
    title: 'Westco Ductwork Design Criteria.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Mechanical',
    fileType: 'PDF',
    url: '/documents/Westco Ductwork Design Criteria.pdf',
    content: 'Sheet metal ductwork construction standards, pressure class ratings, and leakage testing procedures.',
    meta: {
      source: 'Westco',
      revision: '01',
      published: '2015',
      size: '5.2 MB',
    },
  },
  {
    id: 'doc-4th-closeout',
    title: '4th Flr Close Out Dec 12 Des Crit.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Building',
    fileType: 'PDF',
    url: '/documents/4th Flr Close Out Dec 12 Des Crit.pdf',
    content: 'Fourth floor fitout closeout design criteria and electrical lighting power densities.',
    meta: {
      source: 'Fitout team',
      revision: '01',
      published: '2012',
      size: '1.8 MB',
    },
  },
  {
    id: 'doc-grd-closeout',
    title: 'Grd Flr Close Out Dec 12 Des Crit.pdf',
    type: 'document',
    category: 'Design criteria',
    discipline: 'Building',
    fileType: 'PDF',
    url: '/documents/Grd Flr Close Out Dec 12 Des Crit.pdf',
    content: 'Ground floor handover and closeout design criteria documentation.',
    meta: {
      source: 'Fitout team',
      revision: '01',
      published: '2012',
      size: '1.7 MB',
    },
  },

  // Assets and Drawings
  {
    id: 'asset-ahu-003',
    title: 'AHU-003 — Air Handling Unit',
    type: 'asset',
    category: 'Asset data',
    discipline: 'Mechanical',
    url: '/asset-data/ahu-003',
    content: 'Air Handling Unit AHU-003 located in Plant Room 01, Building A, Level 01. Trane Climate Changer CCU-240.',
    meta: {
      manufacturer: 'Trane',
      location: 'Building A · Plant Room 01',
    },
  },
  {
    id: 'asset-chwp-002',
    title: 'CHWP-002 — Chilled Water Pump',
    type: 'asset',
    category: 'Asset data',
    discipline: 'Mechanical',
    url: '/asset-data/ahu-003',
    content: 'Chilled Water Pump CHWP-002 serving CHW LTHW closed loop distribution in Plant Room 01.',
    meta: {
      manufacturer: 'Grundfos',
      location: 'Plant Room 01',
    },
  },
  {
    id: 'asset-p-014',
    title: 'P-014 — Heating Pump (Service Due)',
    type: 'asset',
    category: 'Maintenance',
    discipline: 'Mechanical',
    url: '/asset-data/ahu-003',
    content: 'Heating Pump P-014 on LTHW circuit. Planned service due 08 October.',
    meta: {
      location: 'Plant Room 01',
    },
  },
  {
    id: 'asset-db-04',
    title: 'DB-04 — Distribution Board',
    type: 'asset',
    category: 'Asset data',
    discipline: 'Electrical',
    url: '/asset-data/ahu-003',
    content: 'Distribution Board DB-04 providing electrical power to HVAC and ventilation plant in Plant Room 01.',
    meta: {
      location: 'Plant Room 01',
    },
  },
  {
    id: 'drawing-m402',
    title: 'M-402 — Chilled water distribution schematic.dwg',
    type: 'drawing',
    category: 'Drawings',
    discipline: 'Mechanical',
    fileType: 'DWG',
    url: '/drawings',
    content: 'Base-build schematic for the chilled water distribution network, including plant-room connections and riser locations.',
    meta: {
      source: 'CAD room',
      revision: 'P02',
      published: '2016',
    },
  },
  {
    id: 'doc-hse-notification-f10',
    title: 'LG Data Centre HSE Notification F10.pdf',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'PDF',
    url: '/documents/LG Data Centre HSE Notification F10.pdf',
    content: 'Commerzbank LG Data Centre HSE Notification of Work F10 statutory notification.',
    meta: {
      source: 'Commerzbank',
      published: '2018',
    },
  },
  {
    id: 'doc-hitec-ups-hs',
    title: 'HITEC UPS H&S Warnings.pdf',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'PDF',
    url: '/documents/HITEC UPS H&S Warnings.pdf',
    content: 'HITEC Operation & Maintenance Manual Volume 3 diesel uninterruptible power supply warnings and safe operation.',
    meta: {
      source: 'Manual Reference: 887-6',
      published: '2005/6',
    },
  },
  {
    id: 'doc-comms-cabling-hs',
    title: 'Comms IT Cabling  H&S.pdf',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'PDF',
    url: '/documents/Comms IT Cabling  H&S.pdf',
    content: 'Communication IT Structured Cabling health and safety regulations, acts, and BPE.',
    meta: {
      source: 'Manual Ref: 887-12',
      published: '2005/6',
    },
  },
  {
    id: 'doc-lv03-method',
    title: 'LV03 Method Statement (07a. Method Statement(2).doc)',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'DOC',
    url: '/documents/07a. Method Statement(2).doc',
    content: 'Fixed wiring inspection and test switchboard LV03 method statement August 2012.',
    meta: {
      source: 'Gmail Upload',
      published: '2012',
    },
  },
  {
    id: 'doc-lv03-risk',
    title: 'LV03 Risk Assessment (07b. Risk Assessment(2).doc)',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'DOC',
    url: '/documents/07b. Risk Assessment(2).doc',
    content: 'Fixed wiring inspection and test switchboard LV03 risk assessment August 2012.',
    meta: {
      source: 'Gmail Upload',
      published: '2012',
    },
  },
  {
    id: 'doc-lv05-method',
    title: '07a. Method Statement.doc',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'DOC',
    url: '/documents/07a. Method Statement.doc',
    content: 'Fixed wiring inspection and test switchboard LV05 method statement August 2012.',
    meta: {
      source: 'Gmail Upload',
      published: '2012',
    },
  },
  {
    id: 'doc-lv05-risk',
    title: '07b. Risk Assessment.doc',
    type: 'document',
    category: 'Health & Safety',
    discipline: 'Electrical',
    fileType: 'DOC',
    url: '/documents/07b. Risk Assessment.doc',
    content: 'Fixed wiring inspection and test switchboard LV05 risk assessment August 2012.',
    meta: {
      source: 'Gmail Upload',
      published: '2012',
    },
  },
];
